import React from "react";
import PropTypes from "prop-types";

function OuterLink({ link, text }) {
  return (
    <a href={link} target="_blank" className="outer-link">
      {text}
      <i className="las la-arrow-up"></i>
    </a>
  );
}

OuterLink.propTypes = {
  link: PropTypes.string,
  text: PropTypes.string.isRequired,
};

export default OuterLink;
